export default __webpack_public_path__ + "static/media/YtSearchBackground.d4fe2217.png";